import { render, staticRenderFns } from "./TDialog.vue?vue&type=template&id=46279d06"
import script from "./TDialog.vue?vue&type=script&lang=js"
export * from "./TDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports